import { render, staticRenderFns } from "./AddVisitor.vue?vue&type=template&id=08968dbc"
import script from "./AddVisitor.vue?vue&type=script&lang=ts"
export * from "./AddVisitor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports